import { Sun, Moon, Monitor } from 'lucide-react';
import { useThemeStore } from '@stores/theme.store';

export function ThemeToggle(): JSX.Element {
  const { theme, toggleTheme } = useThemeStore();

  const getIcon = (): JSX.Element => {
    switch (theme) {
      case 'light':
        return <Sun size={18} />;
      case 'dark':
        return <Moon size={18} />;
      case 'system':
        return <Monitor size={18} />;
    }
  };

  const getLabel = (): string => {
    switch (theme) {
      case 'light':
        return 'Light mode';
      case 'dark':
        return 'Dark mode';
      case 'system':
        return 'System theme';
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className="group flex items-center gap-2 px-3 py-2 rounded-lg text-ybh-text-muted hover:bg-ybh-bg-tertiary hover:text-ybh-text-primary transition-all duration-200"
      aria-label={`Current: ${getLabel()}. Click to change theme.`}
      title={getLabel()}
    >
      <span className="transition-transform duration-200 group-hover:scale-110">
        {getIcon()}
      </span>
      <span className="text-sm hidden sm:inline">{theme === 'system' ? 'Auto' : theme === 'light' ? 'Light' : 'Dark'}</span>
    </button>
  );
}
